(() => {
    "use strict";

    const USE_HOME_READER_TRANSITION = true;


    // ==========================================================
    // HOME MEMBER LEVEL
    // ==========================================================

    function updateHomeMemberLevel() {
        const level =
            document.querySelector(
                "[data-home-member-level]"
            );

        if (!level) {
            return;
        }

        /*
         * The Handlebars markup already supplies a safe
         * fallback of Public or Member.
         *
         * frAccess refines that to the actual tier.
         */
        if (
            !window.frAccess ||
            typeof window.frAccess.isSignedIn !==
            "function" ||
            typeof window.frAccess.hasTier !==
            "function"
        ) {
            return;
        }

        let label =
            "Public";

        if (
            window.frAccess.isSignedIn()
        ) {
            label =
                "Member";

            if (
                window.frAccess.hasTier(
                    "FamilyTier"
                )
            ) {
                label =
                    "Family";
            }

            /*
             * TomAuthor is the highest-level display label,
             * so test it last.
             */
            if (
                window.frAccess.hasTier(
                    "TomAuthorTier"
                )
            ) {
                label =
                    "TomAuthor";
            }
        }

        level.textContent =
            label;

        level.dataset.homeMemberLevel =
            label.toLowerCase();
    }


    // ==========================================================
    // INITIAL MEMBER LEVEL
    // ==========================================================

    updateHomeMemberLevel();


    // ==========================================================
    // FEATURED AREA
    // ==========================================================

    const featured =
        document.querySelector(
            ".fr-home-minimal-featured"
        );

    if (!featured) {
        return;
    }

    const tabs =
        Array.from(
            featured.querySelectorAll(
                "[data-home-minimal-featured-tab]"
            )
        );

    const writing =
        featured.querySelector(
            "[data-home-minimal-featured-writing]"
        );

    const desk =
        featured.querySelector(
            "[data-home-minimal-featured-desk]"
        );

    const randomWorkButton =
        featured.querySelector(
            "[data-home-minimal-featured-random-work]"
        );

    const randomNoteButton =
        featured.querySelector(
            "[data-home-minimal-featured-random-note]"
        );

    const deskItems =
        desk
            ? Array.from(
                desk.querySelectorAll(
                    "[data-home-minimal-featured-desk-item]"
                )
            )
            : [];

    let currentDeskIndex = 0;


    // ==========================================================
    // TABS
    // ==========================================================

    function showPane(name) {
        const showDesk =
            name ===
            "desk";

        if (writing) {
            writing.hidden =
                showDesk;
        }

        if (desk) {
            desk.hidden =
                !showDesk;
        }

        /*
         * Keep the right rail in place.
         * Only swap the contextual action.
         */
        if (randomWorkButton) {
            randomWorkButton.hidden =
                showDesk;
        }

        if (randomNoteButton) {
            randomNoteButton.hidden =
                !showDesk;
        }

        tabs.forEach(
            (tab) => {
                const active =
                    tab.dataset.homeMinimalFeaturedTab ===
                    name;

                tab.classList.toggle(
                    "is-active",
                    active
                );

                tab.setAttribute(
                    "aria-selected",
                    String(
                        active
                    )
                );
            }
        );
    }


    // ==========================================================
    // NOTEBOOK ITEMS
    // ==========================================================

    function showDeskItem(index) {
        if (
            index < 0 ||
            index >=
            deskItems.length
        ) {
            return;
        }

        currentDeskIndex =
            index;

        deskItems.forEach(
            (
                item,
                itemIndex
            ) => {
                item.hidden =
                    itemIndex !==
                    currentDeskIndex;
            }
        );
    }


    function showRandomDeskItem() {
        if (
            deskItems.length < 2
        ) {
            return;
        }

        let nextIndex =
            currentDeskIndex;

        while (
            nextIndex ===
            currentDeskIndex
            ) {
            nextIndex =
                Math.floor(
                    Math.random() *
                    deskItems.length
                );
        }

        const currentItem =
            deskItems[
                currentDeskIndex
                ];

        const nextItem =
            deskItems[
                nextIndex
                ];

        if (
            !USE_HOME_READER_TRANSITION
        ) {
            showDeskItem(
                nextIndex
            );

            return;
        }

        currentItem.classList.add(
            "is-randomWork-leaving"
        );

        window.setTimeout(
            () => {
                nextItem.classList.add(
                    "is-randomWork-entering"
                );

                showDeskItem(
                    nextIndex
                );

                window.requestAnimationFrame(
                    () => {
                        window.requestAnimationFrame(
                            () => {
                                nextItem.classList.remove(
                                    "is-randomWork-entering"
                                );
                            }
                        );
                    }
                );

                currentItem.classList.remove(
                    "is-randomWork-leaving"
                );
            },
            140
        );
    }


    // ==========================================================
    // EVENTS
    // ==========================================================

    tabs.forEach(
        (tab) => {
            tab.addEventListener(
                "click",
                () => {
                    showPane(
                        tab.dataset.homeMinimalFeaturedTab ||
                        "writing"
                    );
                }
            );
        }
    );

    if (randomNoteButton) {
        randomNoteButton.addEventListener(
            "click",
            (event) => {
                event.preventDefault();

                showRandomDeskItem();
            }
        );
    }


    // ==========================================================
    // INITIALIZE
    // ==========================================================

    if (
        deskItems.length
    ) {
        showDeskItem(
            0
        );
    }

    showPane(
        "writing"
    );

})();